import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            track("login_completed", { method: "email" });
            toast.success("Welcome back");
            navigate("/");
        } else {
            toast.error(res.error || "Login failed");
        }
    };

    const handleGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="ok-container py-16 max-w-md mx-auto" data-testid="login-page">
            <div className="text-center mb-8">
                <div className="inline-block"><Logo /></div>
            </div>
            <div className="ok-card p-8">
                <h1 className="font-display text-2xl mb-1">Log in</h1>
                <p className="text-sm opacity-60 mb-6">Continue contributing to the archive.</p>
                <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Email</label>
                        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ok-input" data-testid="login-email" />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Password</label>
                        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="ok-input" data-testid="login-password" />
                    </div>
                    <button type="submit" disabled={loading} className="ok-btn-primary w-full justify-center" data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
                <div className="my-5 flex items-center gap-3">
                    <div className="flex-1 ok-divider" /><span className="font-mono text-[10px] uppercase tracking-widest opacity-50">OR</span><div className="flex-1 ok-divider" />
                </div>
                <button onClick={handleGoogle} className="ok-btn-outline w-full justify-center" data-testid="login-google">
                    Continue with Google
                </button>
                <p className="text-sm text-center mt-6 opacity-70">
                    No account? <Link to="/signup" className="ok-link" data-testid="login-to-signup">Create one</Link>
                </p>
                <p className="text-xs text-center mt-2 opacity-60">
                    <Link to="/forgot-password" className="ok-link" data-testid="login-forgot-password">Forgot your password?</Link>
                </p>
            </div>
        </div>
    );
}
